import { StyleSheet } from 'react-native';
import {
  black,
  bold,
  fontFamilySemiBold,
  fontSizeMedium,
  white,
} from '../../../constants/palette';

export default StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 22,
  },
  modalView: {
    margin: 20,
    backgroundColor: white,
    borderRadius: 20,
    padding: 35,
    alignItems: 'center',
    shadowColor: black,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  textStyle: {
    color: white,
    fontWeight: bold,
    textAlign: 'center',
  },
  modalText: {
    marginBottom: 15,
    textAlign: 'center',
    fontFamily: fontFamilySemiBold,
    fontSize: fontSizeMedium,
  },
});
